module.exports = __webpack_public_path__ + "static/media/login-image.bd9cbd12.jpg";